import styled from 'styled-components';

export const TooltipContainer = styled.div`
  background: white;
  padding: 4px;
  box-shadow: 0px 1px 16px 4px rgba(79, 82, 104, 0.1),
    0px 1px 8px rgba(79, 82, 104, 0.08), 0px 1px 2px rgba(79, 82, 104, 0.24);
  border-radius: 6px;
  margin-bottom: 6px;
  display: flex;
`;

export const TooltipContainerColumn = styled.div`
  background: white;
  padding: 4px;
  box-shadow: 0px 1px 16px 4px rgba(79, 82, 104, 0.1),
    0px 1px 8px rgba(79, 82, 104, 0.08), 0px 1px 2px rgba(79, 82, 104, 0.24);
  border-radius: 6px;
  margin-bottom: 6px;
  display: flex;
  flex-direction: column;
`;
